var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperClipWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.644,
    height: 15.99,
    viewBox: "0 0 17.644 15.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g610",
    transform: "translate(306.931 555.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path612",
    d: "M-298.392-541.128l7.445-7.445a3.958,3.958,0,0,0,0-5.6h0a3.958,3.958,0,0,0-5.6,0l-8.818,8.818a2.936,2.936,0,0,0,0,4.152h0a2.936,2.936,0,0,0,4.152,0l6.961-6.961a1.914,1.914,0,0,0,0-2.706h0a1.914,1.914,0,0,0-2.706,0l-5.588,5.588",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClipWhite);
export default __webpack_public_path__ + "static/media/paper-clip-white.c03f123f4d6080e684b4338196abece6.svg";
export { ForwardRef as ReactComponent };